/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPressReleaseTypesResponseAllOf,
    GetPressReleaseTypesResponseAllOfFromJSON,
    GetPressReleaseTypesResponseAllOfFromJSONTyped,
    GetPressReleaseTypesResponseAllOfToJSON,
} from './GetPressReleaseTypesResponseAllOf';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';
import {
    PressReleaseType,
    PressReleaseTypeFromJSON,
    PressReleaseTypeFromJSONTyped,
    PressReleaseTypeToJSON,
} from './PressReleaseType';

/**
 * 
 * @export
 * @interface GetPressReleaseTypesResponse
 */
export interface GetPressReleaseTypesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof GetPressReleaseTypesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof GetPressReleaseTypesResponse
     */
    message: string;
    /**
     * 
     * @type {Array<PressReleaseType>}
     * @memberof GetPressReleaseTypesResponse
     */
    data: Array<PressReleaseType>;
}

export function GetPressReleaseTypesResponseFromJSON(json: any): GetPressReleaseTypesResponse {
    return GetPressReleaseTypesResponseFromJSONTyped(json, false);
}

export function GetPressReleaseTypesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseTypesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(PressReleaseTypeFromJSON)),
    };
}

export function GetPressReleaseTypesResponseToJSON(value?: GetPressReleaseTypesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(PressReleaseTypeToJSON)),
    };
}

